var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreasureHuntChestOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 580,
    viewBox: "0 0 580 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 298.164H580V575.474C580 576.679 579.519 577.835 578.663 578.688C577.806 579.54 576.645 580.019 575.434 580.019H4.56603C3.35504 580.019 2.19366 579.54 1.33736 578.688C0.481063 577.835 0 576.679 0 575.474L0 298.164Z",
    fill: "#FFD843"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M548.03 548.178V329.969L31.9676 329.969V548.178H548.03Z",
    fill: "#85403B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M473.438 247.004H289.998H106.562L0 298.146H289.998H580L473.438 247.004Z",
    fill: "#FD9D0A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.563 247.004H289.998H473.439L557.166 145.855H22.8354L106.563 247.004Z",
    fill: "#FD9D0A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M540.025 289.059L461.603 247.007L537.806 154.949H42.1949L118.397 247.007L39.9758 289.059H540.025Z",
    fill: "#6B2E2C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.397 247.007V154.949H42.1948L118.397 247.007Z",
    fill: "#441B1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M461.608 247.007V154.949H537.811L461.608 247.007Z",
    fill: "#441B1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.397 247.004V289.056H39.9758L118.397 247.004Z",
    fill: "#441B1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M461.608 247.004V289.056H540.03L461.608 247.004Z",
    fill: "#441B1B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M557.169 90.9307V145.845H22.8298V90.9307C22.8247 81.9999 24.1417 73.1172 26.7384 64.5687C27.664 61.4773 28.7693 58.442 30.0487 55.4783C37.0431 39.0248 48.753 24.9877 63.7156 15.1207C78.6781 5.25376 96.2299 -0.00550055 114.178 4.31703e-06H465.831C483.775 0.00936966 501.32 5.27519 516.28 15.1412C531.239 25.0073 542.95 39.0373 549.955 55.4829C551.235 58.4466 552.34 61.4818 553.266 64.5732C555.86 73.1205 557.176 82.0017 557.169 90.9307Z",
    fill: "#85403B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M548.024 471.371H31.9622V480.461H548.024V471.371Z",
    fill: "#441B1B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M548.024 397.688H31.9622V406.778H548.024V397.688Z",
    fill: "#441B1B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M553.268 64.5825H26.7502C27.6758 61.4911 28.7811 58.4559 30.0606 55.4922H549.958C551.237 58.4559 552.343 61.4911 553.268 64.5825Z",
    fill: "#441B1B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M523.536 20.4536H56.4766C60.6826 17.0263 65.1909 13.9839 69.9464 11.3633H510.061C514.819 13.9828 519.329 17.0253 523.536 20.4536Z",
    fill: "#441B1B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.139 0H114.176C63.7263 0 22.8284 40.7065 22.8284 90.9034V145.854H54.7906V90.9034C54.7906 40.7065 95.6931 0 146.139 0Z",
    fill: "#FFD843"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M433.859 0H465.821C516.267 0 557.142 40.7065 557.142 90.9034V145.854H525.179V90.9034C525.198 40.7065 484.3 0 433.859 0Z",
    fill: "#FFD843"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M525.197 114.031H54.8042V145.852H525.197V114.031Z",
    fill: "#FFD843"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M300.146 0H279.503C273.928 22.1986 274.024 114.016 274.024 114.016H305.63C305.63 114.016 305.726 22.2077 300.146 0Z",
    fill: "#FFD843"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M305.982 328.523H274.016V548.178H305.982V328.523Z",
    fill: "#FFD843"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasureHuntChestOpen);
export default __webpack_public_path__ + "static/media/treasureHuntChestOpen.aaa930fa16b53093b900269f2687ba9d.svg";
export { ForwardRef as ReactComponent };